import api from './index';

// ========== 商品管理 ==========
export const listProducts = (params) => api.get('/web/mall/product/list', { params });
export const saveProduct = (data) => api.post('/web/mall/product/save', data);
export const updateProduct = (data) => api.put('/web/mall/product/update', data);
export const updateProductStatus = (id, status) => api.put('/web/mall/product/status', null, { params: { id, status } });
export const deleteProduct = (id) => api.delete('/web/mall/product/delete', { params: { id } });
export const listProductTypes = () => api.get('/web/mall/product/type/list');
export const saveProductType = (data) => api.post('/web/mall/product/type/save', data);

// ========== 订单管理 ==========
export const listOrders = (params) => api.get('/web/mall/order/list', { params });
export const getOrderDetail = (orderNo) => api.get('/web/mall/order/detail', { params: { orderNo } });
export const shipOrder = (orderNo, logisticsCompany, trackNo) =>
    api.put('/web/mall/order/ship', null, { params: { orderNo, logisticsCompany, trackNo } });
export const getDashboardStats = () => api.get('/web/mall/order/stat/dashboard');
export const listRefunds = (params) => api.get('/web/mall/order/refund/list', { params });
export const approveRefund = (data) => api.put('/web/mall/order/refund/approve', data);
export const rejectRefund = (data) => api.put('/web/mall/order/refund/reject', data);
export const syncRefund = (data) => api.put('/web/mall/order/refund/sync', data);

// ========== 设备黑名单管理（仅超级管理员） ==========
export const listDeviceBlacklist = (params) =>
    api.get('/web/mall/device-blacklist/page', { params });
export const createDeviceBlacklist = (data) =>
    api.post('/web/mall/device-blacklist', data);
export const updateDeviceBlacklist = (id, data) =>
    api.put(`/web/mall/device-blacklist/${id}`, data);
export const updateDeviceBlacklistStatus = (id, enabled) =>
    api.put(`/web/mall/device-blacklist/${id}/status`, { enabled });
